/* KEYP in-place Mailchimp signup (2026-09-26). Forms with [data-lx-signup] submit to the same Mailchimp
   list through its JSONP endpoint, so shoppers stay on the page and see a confirmation where the form was.
   Without JavaScript the form still posts normally to Mailchimp. Optional hidden input name="tags" carries a
   Mailchimp tag ID set in the section settings. */
(function () {
  if (window.__lxSignup) return;
  window.__lxSignup = true;
  var n = 0;

  function strip(html) { var d = document.createElement('div'); d.innerHTML = html || ''; return (d.textContent || '').replace(/^\s*\d+\s*-\s*/, '').trim(); }

  function msgEl(form) {
    var m = form.parentNode.querySelector('.lx-signup__msg');
    if (!m) { m = document.createElement('p'); m.className = 'lx-signup__msg'; m.setAttribute('role', 'status'); m.setAttribute('aria-live', 'polite'); form.parentNode.insertBefore(m, form.nextSibling); }
    return m;
  }

  function submit(form, e) {
    var email = form.querySelector('input[name="EMAIL"]');
    if (!email || !email.value || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) {
      e.preventDefault();
      var m0 = msgEl(form); m0.className = 'lx-signup__msg is-error'; m0.textContent = form.getAttribute('data-msg-invalid') || 'Please enter a valid email address.';
      if (email) email.focus();
      return;
    }
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    var cb = '__lxMc' + (++n) + '_' + Math.floor(Math.random() * 1e6);
    var params = [];
    Array.prototype.forEach.call(form.elements, function (el) { if (el.name) params.push(encodeURIComponent(el.name) + '=' + encodeURIComponent(el.value)); });
    var url = form.action.replace('/subscribe/post?', '/subscribe/post-json?') + '&' + params.join('&') + '&c=' + cb;
    var s = document.createElement('script');
    var done = function (ok, text) {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
      var m = msgEl(form);
      m.className = 'lx-signup__msg ' + (ok ? 'is-ok' : 'is-error');
      m.textContent = text;
      if (ok) { form.classList.add('is-done'); form.reset(); try { form.dispatchEvent(new CustomEvent('lx:signup', { bubbles: true, detail: { ok: true } })); } catch (x) {} }
      try { delete window[cb]; } catch (x) { window[cb] = undefined; }
      if (s.parentNode) s.parentNode.removeChild(s);
    };
    var timer = setTimeout(function () { done(false, form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.'); }, 12000);
    window[cb] = function (res) {
      clearTimeout(timer);
      if (res && res.result === 'success') done(true, form.getAttribute('data-msg-ok') || "You're in. Check your inbox to confirm.");
      else {
        var t = strip(res && res.msg);
        if (/already subscribed/i.test(t)) done(true, form.getAttribute('data-msg-already') || "You're already on the list.");
        else done(false, t || form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.');
      }
    };
    s.src = url;
    s.onerror = function () { clearTimeout(timer); done(false, form.getAttribute('data-msg-error') || 'Something went wrong. Please try again.'); };
    document.body.appendChild(s);
  }

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.matches && f.matches('form[data-lx-signup]') && /list-manage\.com\/subscribe\/post\?/.test(f.action)) submit(f, e);
  });
})();
